const API_MAP_KEY = `https://api-maps.yandex.ru/2.1/?apikey=e15c0dbf-09e3-4720-801a-0f649780b44b&lang=ru_RU`;

const MAPS = Array.from(document.querySelectorAll(`div.map`));

const DefaultPinProperties = {
	PATH: `/styles/images/map/pin.svg`,
	WIDTH: 20,
	HEIGHT: 20,
};

const GroupPinProperties = {
	WIDTH: 58,
	HEIGHT: 58,
};

const ONLY_MARKER_ZOOM = 14;

export {API_MAP_KEY, MAPS, DefaultPinProperties, GroupPinProperties, ONLY_MARKER_ZOOM};
